<script lang="ts" context="module">
	declare const jQuery: any;
</script>

<script lang="ts">
	import { onMount } from 'svelte';

	onMount(() => {
		/* ~~~ Hero Half Slider ~~~ */
		jQuery('.default-slider').slick();

		// onDestroy equivalent - using this since it should only run client side
		return () => {
			jQuery('.default-slider').slick('unslick');
		};
	});
</script>

<section class="home-slider" id="home">
	<div class="default-slider slick">
		<slot />
	</div>
</section>
